export default "__VITE_ASSET__BM2$4hQe__"